import React from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as CloseIcon } from '../../assets/images/close-icon.svg';
import ButtonWithIcon from '../shared/ButtonWithIcon/ButtonWithIcon';
import Modal from '../shared/Modal/Modal';

import styles from './RemoveConfirmationModal.module.scss';

export const RemoveConfirmationModal = ({ show, onClose, type, onRemove, isLoading }) => {
  const { t } = useTranslation('common');
  return (
    <Modal show={show} onHide={onClose} centered dialogClassName={styles.referralModal}>
      <button type="button" className={styles.closeButton} onClick={onClose} aria-label="Close">
        <CloseIcon />
      </button>
      <Modal.Body className={styles.modalBody}>
        <p className={styles.modalTitle}>{t('modals.areYouSure')}</p>
        <p className={styles.modalDescription}>{t('network.removeAccountDescription', { type })}</p>
      </Modal.Body>
      <Modal.Footer className={styles.modalFooter}>
        <ButtonWithIcon variant="tertiary-36" onClick={onClose} text={t('cancel')} />
        <ButtonWithIcon
          variant="primary-36"
          onClick={onRemove}
          text={t('remove')}
          containerClass={styles.removeButton}
          disabled={isLoading}
        />
      </Modal.Footer>
    </Modal>
  );
};
